export const enDic = {
  'tag.title'                                             : 'jbChess',
  'view.common.yes'                                       : 'Yes',
  'view.common.no'                                        : 'No',
  'view.common.ok'                                        : 'Ok',
  'view.common.cancel'                                    : 'Cancel',
  'view.common.username'                                  : 'Username',
  'view.common.email'                                     : 'Email',
  'view.common.password'                                  : 'Password',
  'view.common.repeat_password'                           : 'Repeat Password',
  'view.common.invalid_value'                             : 'Invalid value',
  'view.common.required_field'                            : 'Required field',
  'view.common.logout'                                    : 'Log Out',
  'scripts.common.oauth.interceptor.connection_error'     : 'Error',
  'scripts.common.oauth.interceptor.forbidden'            : 'Forbidden',
  'scripts.common.oauth.interceptor.internal_server_error': 'Internal Error',
  'scripts.common.oauth.interceptor.service_unavailable'  : 'Service Unavailable',
  'scripts.common.oauth.interceptor.bad_request_error'    : 'Bad Request',
  'views.page-not-found.title'                            : 'Page Not Found',
  'views.page-not-found.message'                          : 'Sorry, it seems this page does not exist',
  'view.sign.email_tip'                                   : 'Please provide a valid email address. A verification with a confirmation will be sent through to activate your new account. This will be your user ID to login into the app.',
  'view.sign.sent_msg'                                    : 'A verification link has been sent to your email address. Please use it to finish your account activation',
  'page.label.login'                                      : 'Login',
  'page.label.home'                                       : 'Home',
  'view.login.text'                                       : 'Login',
  'view.login.log_in_btn'                                 : 'Login',
  'view.login.reset_forgotten_password'                   : 'Forgot Password?',
  'view.login.new_user'                                   : 'Sign in (new user)',
  'view.login.sign_in'                                    : 'Sign In',
  'view.repeat_password'                                  : 'Repeat Password',
  'view.login.user_not_activated'                         : 'Please, use the link on the email to activate your account',
  'view.profile.title'                                    : 'Profile',
  'view.profile.update'                                   : 'Update',
  'view.profile.display_name'                             : 'Display Name',
  'view.profile.updated_successfully'                     : 'Profile updated successfully',
  'view.profile.confirm_logout'                           : 'Do you want to log out?',
  'view.games.title':  'Games',
  'view.games.new_game': 'New Game',
  'view.games.request_send': 'A new game request has been sent, please wait for someone to join',
  'view.games.player1': 'Player 1',
  'view.games.player2': 'Player 2',
  'view.games.no_games': 'No Games',
  'view.games.request_date': 'Request Date',
  'view.game.select_piece.header': 'Select a Piece',
  'view.game.check_mate': 'Check Mate',
  'view.game.turn': 'Turn around',
  'view.game.analyse': 'Analise mode',
  'view.game.prev_move': 'Previous move',
  'view.game.next_move': 'Next move',
  'view.game.reset': 'Reset to current move',
  'view.game.finish_tooltip': 'Finish game',
  'view.game.back_tooltip': 'Go back to all games',
  'view.game.details': 'Game Details',
  'view.game.finish_confirmation': 'Are you sure you want to give up?',
  'view.game.unknown_player': 'Unknown player',
  'views.game.tabs.moves': 'Moves',
  'views.game.tabs.chat': 'Chat',
  'views.game.tabs.video': 'Video',
  'view.game.win_by_timeout': 'Win By Timeout',
  'view.game.win_by_resign': 'Win By Resignation',
  'view.modal.confirm.text': 'Are you sure?',
  'view.common.status': 'Status',
  'view.common.id': 'Id',
  'view.common.join': 'Join',
  'view.common.go': 'Go',
  'view.common.search': 'Search',
  'view.common.game': 'Game',
  'view.common.back': 'Back',
  'views.common.5_items_per_page': '5 Items per page',
  'views.common.10_items_per_page': '10 Items per page',
  'views.common.15_items_per_page': '15 Items per page',
  'views.common.20_items_per_page': '20 Items per page',
  'views.common.30_items_per_page': '30 Items per page',
  'views.common.50_items_per_page': '50 Items per page',
};
